// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wmrS","toggleWrap":"styles_toggleWrap__1CI-F","content":"styles_content__RSS0p","selectAreaCode":"styles_selectAreaCode__zp0NS"};